<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/user' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>团队管理</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="user" class="demo-form-inline">
                    <el-form-item label="团队名称">
                        <el-input v-model="user.userName" placeholder="用户名"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="queryUser">查询</el-button>
                        <el-button type="primary" @click="createUser">新增</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="users"
                    border
                    style="width: 100%">
                    <el-table-column fixed prop="userName" label="用户名" width="200"></el-table-column>
                    <el-table-column prop="realName" label="真实姓名" width="200"></el-table-column>
                    <el-table-column prop="userType" label="用户类型" width="150"></el-table-column>
                    <el-table-column prop="teamName" label="归属团队" width="200"></el-table-column>
                    <el-table-column prop="status" label="状态" width="200"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="update(scope.row)" type="text" size="small">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10,20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!--  -->

        <el-drawer
            :title="title"
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose">
            <UserUpdate :key="timer" :userProp="userProp"></UserUpdate>
        </el-drawer>
        
    </div>
    
</template>

<script>
    import UserUpdate from './UserUpdate.vue';

    export default {
        name:'User',
        components: {
            UserUpdate
        },
        data() {
            return {
                user:{
                    userName:'',
                    status:'',
                    pageNum:0,
                    pageSize:0
                },
                drawer: false,
                direction: 'rtl',
                users: [],
                currentPage: 1,
                pageSize:10,
                total:10,
                timer:'',
                userProp:{},
                title:"新增用户"
            }
        },
        methods: {
            update(row) {
                this.title = "修改用户";
                this.drawer = true;
                this.userProp = row;
                this.timer = new Date().getTime();
            },
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryUser();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryUser();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryUser();
                })
                .catch(() => {});
            },
            queryUser() {
                this.user.pageNum = this.currentPage;
                this.user.pageSize = this.pageSize;
                this.$axios.post("/user/pageUser",this.user).then(
                    res=>{
                        //console.log(res.data.status);
                        if(res.data.status === "success"){
                            this.users = res.data.result.records;
                            this.total = res.data.result.total;
                            this.pageSize = res.data.result.size;
                            this.currentPage = res.data.result.current;
                        }
                    },
                    error=>{
                        //console.log(error.message);
                        this.$message.error(error.message);
                    }
                )
            },
            createUser() {
                this.title = "新增用户";
                this.drawer = true;
                this.timer = new Date().getTime();
                this.userProp = {};
            }
        },
        mounted() {
            this.queryUser();
        }
        
    }


</script>

<style scoped>

   .el-row {
       margin-top: 30px;
       text-align: left;
       padding-left: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

</style>
